import i18n from "i18next";

const i18nProfile = i18n.cloneInstance();

export default i18nProfile;
